import "./CaseNavigationTabs.css";

import { useState } from "react";
import { useLocation } from "react-router-dom";

import {
  availableSubQueues,
  QueueEnum,
  SubQueueFilters,
} from "shared/reducers/casesReducer";
import { FeatureFlags } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";
import { ApplicationState } from "store/store";

import CaseNavigationTab from "./CaseNavigationTab";

const CaseNavigationTabsController = ({
  queue,
  subQueue,
  setSubQueue,
  gotoPage,
}: {
  queue: QueueEnum;
  subQueue?: keyof typeof SubQueueFilters;

  setSubQueue: Function;
  gotoPage: Function;
}) => {
  const features: FeatureFlags = useAppSelector(
    ({ sys }: ApplicationState) => sys.features
  );

  const location = useLocation();

  const [subQueueList, setSubQueueList] = useState<QueueEnum>(queue);
  const subQueues =
    availableSubQueues[subQueueList as keyof typeof availableSubQueues];

  const getSearchString = (subQueue?: keyof typeof SubQueueFilters) => {
    const usp = new URLSearchParams(location.search);

    subQueue ? usp.set("subQueue", subQueue) : usp.delete("subQueue");

    // Remove sort when changing queues
    usp.delete("sortColumn");

    return usp.size > 0 ? `?${usp.toString()}` : "";
  };

  return (
    <div className="CaseNavigation__container">
      <div className="CaseNavigationTabs__container">
        {[
          ...(features?.orderedCaseViewer && features?.slidelessViewer
            ? ["ordered"]
            : []),
          "working",
          "active",
          ...(features?.issuePrelimReports ? ["preliminary"] : []),
          ...(features?.requestScreen ? ["screened"] : ["screen"]),
          ...(features?.flaggedFilter ? ["flagged"] : []),
          "finalized",
          "all",
        ].map((type) => (
          <CaseNavigationTab
            key={type}
            queue={type as QueueEnum}
            selectedQueue={queue}
            handleOnClick={() => {
              setSubQueueList(type as QueueEnum);
              setSubQueue(undefined);
              type === "all" &&
                localStorage.setItem("caselist_default_view", type);
            }}
            link={`/${type}${getSearchString(undefined)}`}
            gotoPage={gotoPage}
          />
        ))}
      </div>
      {!!subQueues?.length && features?.caseSubQueues && (
        <div className="CaseNavigationTabs__container">
          <CaseNavigationTab
            queue="all"
            selectedQueue={
              subQueueList === queue ? subQueue ?? "all" : undefined
            }
            isSubQueue
            handleOnClick={() => setSubQueue(undefined)}
            link={`/${subQueueList}${getSearchString(undefined)}`}
            gotoPage={gotoPage}
          />
          {subQueues.map((subQueueType) => (
            <CaseNavigationTab
              key={subQueueType}
              queue={subQueueType as keyof typeof SubQueueFilters}
              selectedQueue={subQueue}
              isSubQueue
              handleOnClick={() => setSubQueue(subQueueType)}
              link={`/${subQueueList}${getSearchString(
                subQueueType as keyof typeof SubQueueFilters
              )}`}
              gotoPage={gotoPage}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CaseNavigationTabsController;
